import * as React from "react";
const SvgDoneIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeWidth: 1.5, d: "m3 8 4 4 7-7" }));
export default SvgDoneIcon;
